import React from 'react';
import PropTypes from 'prop-types';
import {
  CircularProgress,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Popper,
} from '@mui/material';

import { mentionUsersListSx, popperStyle } from './styles';
import texts from './texts.json';

const MentionPopper = ({
  open,
  anchorEl,
  isLoading,
  users,
  onMentionSelect,
}) => (
  <Popper
    open={open}
    anchorEl={anchorEl}
    placement="top-start"
    style={popperStyle(anchorEl)}
  >
    <Paper elevation={3}>
      {isLoading && (
        <List dense>
          <ListItemButton disabled>
            <CircularProgress size={20} />
          </ListItemButton>
        </List>
      )}
      {!isLoading && users.length > 0 && (
        <List dense sx={mentionUsersListSx}>
          {users.map((user) => (
            <ListItemButton
              key={user.id}
              onMouseDown={(e) => {
                e.preventDefault();
                onMentionSelect(user);
              }}
            >
              <ListItemText primary={user.displayName} secondary={`@${user.name}`} />
            </ListItemButton>
          ))}
        </List>
      )}
      {!isLoading && users.length === 0 && (
        <List dense>
          <ListItemButton disabled>
            <ListItemText primary={texts.noMentionResults} />
          </ListItemButton>
        </List>
      )}
    </Paper>
  </Popper>
);

MentionPopper.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.shape({
    offsetWidth: PropTypes.number,
  }),
  isLoading: PropTypes.bool.isRequired,
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    displayName: PropTypes.string,
  })).isRequired,
  onMentionSelect: PropTypes.func.isRequired,
};

MentionPopper.defaultProps = {
  anchorEl: null,
};

export default MentionPopper;
